/**
 * VPN Module Routes — granular (2026-04-21)
 */

import { lazy } from "react";
import { ModuleRoutes } from "../types";

const VPNMatriz = lazy(() => import("@/pages/vpn/Matriz"));
const VpnDashboardPage = lazy(() =>
  import("@/pages/vpn/VpnDashboardPage").then((m) => ({ default: m.VpnDashboardPage }))
);
const VPNLista = lazy(() => import("@/pages/vpn/Lista"));
const VPNCadastro = lazy(() => import("@/pages/vpn/Cadastro"));
const BulkVpnPage = lazy(() => import("@/pages/vpn/BulkVpnPage"));
const VPNLogsOperacoes = lazy(() => import("@/pages/vpn/LogsOperacoes"));
const VpnLogsPage = lazy(() => import("@/pages/vpn/VpnLogsPage"));
const VPNDetalhes = lazy(() => import("@/pages/vpn/Detalhes"));
const VpnAccessPage = lazy(() =>
  import("@/pages/vpn/VpnAccessPage").then((m) => ({ default: m.VpnAccessPage }))
);

export const vpnRoutes: ModuleRoutes = {
  moduleId: "vpn",
  basePath: "/vpn",
  routes: [
    {
      path: "/vpn/matriz",
      element: <VPNMatriz />,
      permission: { resource: "vpn_matriz", action: "view" },
    },
    {
      path: "/vpn/dashboard",
      element: <VpnDashboardPage />,
      permission: { resource: "vpn_dashboard", action: "view" },
    },
    {
      path: "/vpn/lista",
      element: <VPNLista />,
      permission: { resource: "vpn_lista", action: "view" },
    },
    {
      path: "/vpn/cadastro",
      element: <VPNCadastro />,
      permission: { resource: "vpn_cadastro", action: "manage" },
    },
    {
      path: "/vpn/cadastro-lote",
      element: <BulkVpnPage />,
      permission: { resource: "vpn_cadastro", action: "manage" },
    },
    {
      path: "/vpn/logs-operacoes",
      element: <VPNLogsOperacoes />,
      permission: { resource: "vpn_logs_operacoes", action: "view" },
    },
    {
      path: "/vpn/logs-conexoes",
      element: <VpnLogsPage />,
      permission: { resource: "vpn_logs_conexoes", action: "view" },
    },
    {
      path: "/vpn/detalhes/:id",
      element: <VPNDetalhes />,
      permission: { resource: "vpn_lista", action: "view" },
    },
    {
      path: "/vpn/acessos",
      element: <VpnAccessPage />,
      permission: { resource: "vpn_lista", action: "view" },
    },
  ],
};
